import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94e458e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

import { reactive } from 'vue'
import { IonTitle, IonButton, IonButtons, IonToolbar, IonHeader, IonContent,
         IonModal, IonInput, IonItem, IonList } from '@ionic/vue'

import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@/modules/i18n-validators'
import { UserCredentials } from '@/models/UserCredentials'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormLoginModal',
  props: {
    display: { type: Boolean }
  },
  emits: ["update:display", "save"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const userInit: UserCredentials = {
  nif: '',
  email: '',
  phone: ''
}

const user = reactive<UserCredentials>({ ...userInit })

const rules = {
  nif: { required },
  email: { required, email },
  phone: { required }
}

const v$ = useVuelidate(rules, user, { $lazy: false, $autoDirty: true })

const validate = async () => {
  const valid = await v$.value.$validate()
  if (!valid) return

  save()
}

const save = () => {
  emit('save', user)
  close()
}

const close = () => {
  emit('update:display', false)
}

const onWillPresent = () => {
  Object.assign(user, userInit)
  v$.value.$reset()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    "is-open": _ctx.display,
    onWillPresent: onWillPresent
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Identificación")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), { onClick: close }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cerrar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createVNode(_unref(IonList), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonInput), {
                      label: "NIF / NIE / CIF *",
                      "label-placement": "floating",
                      placeholder: "Introduzca su identificación",
                      "error-text": _unref(v$).nif.$errors[0]?.$message,
                      class: _normalizeClass({'ion-invalid ion-touched': _unref(v$).nif.$error}),
                      modelValue: user.nif,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.nif) = $event))
                    }, null, 8, ["error-text", "class", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonInput), {
                      label: "Email *",
                      "label-placement": "floating",
                      placeholder: "Introduzca su correo electrónico",
                      type: "email",
                      "error-text": _unref(v$).email.$errors[0]?.$message,
                      class: _normalizeClass({'ion-invalid ion-touched': _unref(v$).email.$error}),
                      modelValue: user.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.email) = $event))
                    }, null, 8, ["error-text", "class", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonInput), {
                      label: "Teléfono *",
                      "label-placement": "floating",
                      placeholder: "Introduzca su teléfono",
                      type: "tel",
                      "error-text": _unref(v$).phone.$errors[0]?.$message,
                      class: _normalizeClass({'ion-invalid ion-touched': _unref(v$).phone.$error}),
                      modelValue: user.phone,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.phone) = $event))
                    }, null, 8, ["error-text", "class", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              expand: "block",
              disabled: _unref(v$).$invalid,
              onClick: validate
            }, {
              default: _withCtx(() => [
                _createTextVNode("Enviar")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})